import React, { useEffect, useState } from "react";
import { Container, Typography, Box } from "@mui/material";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import axios from "axios";
import HomeCard2 from "../Component/HomeCard/Homecard2";

export default function Bathroom() {
  const [Bathroom, setBathroom] = useState([]);

  useEffect(() => {
    const fetchBathroom = async () => {
      try {
        const response = await axios.get(
          `https://urbancasabackendfiles.onrender.com/api/innerProjects?category=Bathroom`
        );
        setBathroom(response.data);
      } catch (error) {
        console.error("Error fetching custom homes:", error);
      }
    };

    fetchBathroom();
  }, []);

  return (
    <div>
      <VideoCorousel />

      <Container maxWidth="80%" style={{ padding: "40px" }}>
        <Typography variant="h3" align="center" gutterBottom>
          Bathroom Designs
        </Typography>

        <Box display="flex" justifyContent="center" flexWrap="wrap" gap="2vw">
          {Bathroom.map((home) => (
           <Box key={home._id} sx={{ width: { xs: "100%", sm: "45%", md: "30%" } }}>
              {/* <HomeCard home={home} /> */}
              <HomeCard2 home={home} />
            </Box>
          ))}
        </Box>
      </Container>
    </div>
  );
}
